export var HppSingleInvoiceValidationMode;
(function (HppSingleInvoiceValidationMode) {
    HppSingleInvoiceValidationMode["VALIDATION_REQUIRED"] = "VALIDATION_REQUIRED";
    HppSingleInvoiceValidationMode["RATE_LIMIT_BYPASS_ONLY"] = "RATE_LIMIT_BYPASS_ONLY";
    HppSingleInvoiceValidationMode["BYPASS_ENABLED"] = "BYPASS_ENABLED";
})(HppSingleInvoiceValidationMode || (HppSingleInvoiceValidationMode = {}));
//# sourceMappingURL=HppSingleInvoiceValidationMode.js.map